// src/pages/VeilleRequest.jsx
import React from 'react';
import styled from 'styled-components';
import Header from '../components/Header';
import VeilleForm from '../components/VeilleForm';

const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Content = styled.main`
  flex-grow: 1;
  padding: 2rem;
`;

const VeilleRequest = () => {
  return (
    <PageContainer>
      <Header />
      <Content>
        <h1>Nouvelle demande de veille</h1>
        <p>Utilisez le formulaire ci-dessous pour créer une nouvelle veille thématique.</p>
        <VeilleForm />
      </Content>
    </PageContainer>
  );
};

export default VeilleRequest;